import { EmployeePermissionsType, SaturnPermissionType } from '@core/classes/SharedEnums';
import EnumHelper, { EnumToList, ToListItems } from '@core/helpers/enum-helper';
import { SaturnPermissions } from '@core/classes/AccessEmployeeClass';

const EmployeePermissionsMap: EnumToList<EmployeePermissionsType> = {
	// #region Main Menu Sections
	[EmployeePermissionsType.AccessCustomersPage]: {
		display: 'Access Customers Page',
		value: EmployeePermissionsType.AccessCustomersPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessDealsPage]: {
		display: 'Access Deals Page',
		value: EmployeePermissionsType.AccessDealsPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessCancelCoveragePage]: {
		display: 'Access Cancel Coverage Page',
		value: EmployeePermissionsType.AccessCancelCoveragePage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessServiceLookupPage]: {
		display: 'Access Service Lookup Page',
		value: EmployeePermissionsType.AccessServiceLookupPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessReportsPage]: {
		display: 'Access Reports Page',
		value: EmployeePermissionsType.AccessReportsPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessSettingsPage]: {
		display: 'Access Settings Page',
		value: EmployeePermissionsType.AccessSettingsPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessUtilitiesPage]: {
		display: 'Access Utilities Page',
		value: EmployeePermissionsType.AccessUtilitiesPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessAccountingPage]: {
		display: 'Access Accounting Page',
		value: EmployeePermissionsType.AccessAccountingPage,
		type: SaturnPermissionType.Pages,
	},
	[EmployeePermissionsType.AccessSandboxPage]: {
		display: 'Access Sandbox Page',
		value: EmployeePermissionsType.AccessSandboxPage,
		type: SaturnPermissionType.Pages,
	},
	// #endregion

	// #region Customers Section
	[EmployeePermissionsType.ViewUnverifiedCustomersTab]: {
		display: 'View Unverified Customers (Tab)',
		value: EmployeePermissionsType.ViewUnverifiedCustomersTab,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.CompleteQuoteAction]: {
		display: 'Complete Quote (Action)',
		value: EmployeePermissionsType.CompleteQuoteAction,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewVerifiedCustomersTab]: {
		display: 'View Verified Customers (Tab)',
		value: EmployeePermissionsType.ViewVerifiedCustomersTab,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.AddNewCustomerAction]: {
		display: 'Create New Customer (Action)',
		value: EmployeePermissionsType.AddNewCustomerAction,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewCustomerAction]: {
		display: 'View Customer Information (Action)',
		value: EmployeePermissionsType.ViewCustomerAction,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewFullSSN]: {
		display: 'View Customer Full SSN',
		value: EmployeePermissionsType.ViewFullSSN,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.SkipIdentityVerification]: {
		display: 'Skip Customer Identity Verification',
		value: EmployeePermissionsType.SkipIdentityVerification,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.PerformIdentityVerification]: {
		display: 'Perform Customer Identity Verification',
		value: EmployeePermissionsType.PerformIdentityVerification,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewRedFlags]: {
		display: 'View Customer Red Flags',
		value: EmployeePermissionsType.ViewRedFlags,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewCreditReport]: {
		display: 'View Customer Credit Report',
		value: EmployeePermissionsType.ViewCreditReport,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewHousingAndEmploymentInfo]: {
		display: 'View Customer Housing and Employment Info',
		value: EmployeePermissionsType.ViewHousingAndEmploymentInfo,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewQuotesTable]: {
		display: 'View Customer Quotes Table',
		value: EmployeePermissionsType.ViewQuotesTable,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.CreateNewQuoteAction]: {
		display: 'Create New Quote (Action)',
		value: EmployeePermissionsType.CreateNewQuoteAction,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewDealsTable]: {
		display: 'View Deals Table',
		value: EmployeePermissionsType.ViewDealsTable,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewQuotesTab]: {
		display: 'View Quotes Tab',
		value: EmployeePermissionsType.ViewQuotesTab,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.ViewDealsTab]: {
		display: 'View Deals Tab',
		value: EmployeePermissionsType.ViewDealsTab,
		type: SaturnPermissionType.Customers,
	},
	[EmployeePermissionsType.AllowCustomerMeetings]: {
		display: 'Allow Customer Meetings',
		value: EmployeePermissionsType.AllowCustomerMeetings,
		type: SaturnPermissionType.Customers,
	},
	// #endregion

	// #region Deals Section
	[EmployeePermissionsType.ConvertQuoteToDeal]: {
		display: 'Convert Quote to Deal',
		value: EmployeePermissionsType.ConvertQuoteToDeal,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.AllowToResolveApprovalRequests]: {
		display: 'Allow to Resolve Approval Requests',
		value: EmployeePermissionsType.AllowToResolveApprovalRequests,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewCustomerInformation]: {
		display: 'View Customer Information (In Deal)',
		value: EmployeePermissionsType.ViewCustomerInformation,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewVehicleInformation]: {
		display: 'View Vehicle Information (In Deal)',
		value: EmployeePermissionsType.ViewVehicleInformation,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewTradeInInformation]: {
		display: 'View Trade In Information (In Deal)',
		value: EmployeePermissionsType.ViewTradeInInformation,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewRegistrationAndTitling]: {
		display: 'View Registration and Titling (In Deal)',
		value: EmployeePermissionsType.ViewRegistrationAndTitling,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewPurchaseFigures]: {
		display: 'View Purchase Figures (In Deal)',
		value: EmployeePermissionsType.ViewPurchaseFigures,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.SendDealBackToSalesPerson]: {
		display: 'Send Deal Back to Sales Person (In Deal)',
		value: EmployeePermissionsType.SendDealBackToSalesPerson,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.SendDealBackToSalesManager]: {
		display: 'Send Deal Back to Sales Manager (In Deal)',
		value: EmployeePermissionsType.SendDealBackToSalesManager,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.SendDealBackToFIManager]: {
		display: 'Send Deal Back to FI Manager (In Deal)',
		value: EmployeePermissionsType.SendDealBackToFIManager,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.SendDealBackToFIAdmin]: {
		display: 'Send Deal Back to FI Admin (In Deal)',
		value: EmployeePermissionsType.SendDealBackToFIAdmin,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewInsuranceInformation]: {
		display: 'View Insurance Information (In Deal)',
		value: EmployeePermissionsType.ViewInsuranceInformation,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.AccessFIMenu]: {
		display: 'Access FI Menu (In Deal)',
		value: EmployeePermissionsType.AccessFIMenu,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewDealRecap]: {
		display: 'View Deal Recap (In Deal)',
		value: EmployeePermissionsType.ViewDealRecap,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewDealJacket]: {
		display: 'View Deal Jacket (In Deal)',
		value: EmployeePermissionsType.ViewDealJacket,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.AccessFIAdmin]: {
		display: 'View FI Admin (In Deal)',
		value: EmployeePermissionsType.AccessFIAdmin,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.ViewPosting]: {
		display: 'View Posting (In Deal)',
		value: EmployeePermissionsType.ViewPosting,
		type: SaturnPermissionType.Deals,
	},
	[EmployeePermissionsType.PerformDealAudit]: {
		display: 'View Deal Audit (In Deal)',
		value: EmployeePermissionsType.PerformDealAudit,
		type: SaturnPermissionType.Deals,
	},
	// #endregion

	// #region Cancel Coverage Section
	[EmployeePermissionsType.CreateCancellation]: {
		display: 'Cancellation - Create (Action)',
		value: EmployeePermissionsType.CreateCancellation,
		type: SaturnPermissionType.CancelCoverage,
	},
	[EmployeePermissionsType.EditCancellation]: {
		display: 'Cancellation - Edit (Action)',
		value: EmployeePermissionsType.EditCancellation,
		type: SaturnPermissionType.CancelCoverage,
	},
	[EmployeePermissionsType.ViewCancellation]: {
		display: 'Cancellation - View (Action)',
		value: EmployeePermissionsType.ViewCancellation,
		type: SaturnPermissionType.CancelCoverage,
	},
	// #endregion

	// #region Service Lookup Section
	[EmployeePermissionsType.AccessServiceLookup]: {
		display: 'Access Service Lookup Section',
		value: EmployeePermissionsType.AccessServiceLookup,
		type: SaturnPermissionType.ServiceLookup,
	},
	// #endregion

	// #region Reports Section
	[EmployeePermissionsType.AccessCreditReport]: {
		display: 'Reports - Access Credit (Action)',
		value: EmployeePermissionsType.AccessCreditReport,
		type: SaturnPermissionType.Reports,
	},
	[EmployeePermissionsType.AccessFIReport]: {
		display: 'Reports - Access FI (Action)',
		value: EmployeePermissionsType.AccessFIReport,
		type: SaturnPermissionType.Reports,
	},
	[EmployeePermissionsType.AccessDealsReport]: {
		display: 'Reports - Access Deals (Action)',
		value: EmployeePermissionsType.AccessDealsReport,
		type: SaturnPermissionType.Reports,
	},
	// #endregion

	// #region Settings Section
	[EmployeePermissionsType.ManageUsers]: {
		display: 'Settings - Manage Users (Action)',
		value: EmployeePermissionsType.ManageUsers,
		type: SaturnPermissionType.Settings,
	},
	[EmployeePermissionsType.ManageAccountingSettings]: {
		display: 'Settings - Manage Accounting Settings (Action)',
		value: EmployeePermissionsType.ManageAccountingSettings,
		type: SaturnPermissionType.Settings,
	},
	[EmployeePermissionsType.ManageStoreSettings]: {
		display: 'Settings - Manage Store Settings (Action)',
		value: EmployeePermissionsType.ManageStoreSettings,
		type: SaturnPermissionType.Settings,
	},
	// #endregion

	// #region Utilities Section
	[EmployeePermissionsType.CanBroadcast]: {
		display: 'Can Broadcast (Action)',
		value: EmployeePermissionsType.CanBroadcast,
		type: SaturnPermissionType.Utilities,
	},
	[EmployeePermissionsType.CanSendMassText]: {
		display: 'Can Send Mass Text (Action)',
		value: EmployeePermissionsType.CanSendMassText,
		type: SaturnPermissionType.Utilities,
	},
	[EmployeePermissionsType.CanSendMassEmail]: {
		display: 'Can Send Mass Email (Action)',
		value: EmployeePermissionsType.CanSendMassEmail,
		type: SaturnPermissionType.Utilities,
	},

	// #endregion

	// #region Checklist Items
	[EmployeePermissionsType.SalesPersonChecklist]: {
		display: 'Checklist - Sales Person',
		value: EmployeePermissionsType.SalesPersonChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.SalesPerson,
	},
	[EmployeePermissionsType.SalesManagerChecklist]: {
		display: 'Checklist - Sales Manager',
		value: EmployeePermissionsType.SalesManagerChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.SalesManager,
	},
	[EmployeePermissionsType.FIManagerChecklist]: {
		display: 'Checklist - FI Manager',
		value: EmployeePermissionsType.FIManagerChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.FIManager,
	},
	[EmployeePermissionsType.FIAdminChecklist]: {
		display: 'Checklist - FI Admin',
		value: EmployeePermissionsType.FIAdminChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.FIAdmin,
	},
	[EmployeePermissionsType.CostingClerkChecklist]: {
		display: 'Checklist - Costing Clerk',
		value: EmployeePermissionsType.CostingClerkChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.Accounting,
	},
	[EmployeePermissionsType.TitlingChecklist]: {
		display: 'Checklist - Titling',
		value: EmployeePermissionsType.TitlingChecklist,
		type: SaturnPermissionType.Checklist,
		bitFlagValue: SaturnPermissions.TitleClerk,
	},
	// #endregion

	// #region Special Permissions
	[EmployeePermissionsType.AccessCashBash]: {
		display: 'Access Cash Bash (Action)',
		value: EmployeePermissionsType.AccessCashBash,
		type: SaturnPermissionType.Other,
	},
	[EmployeePermissionsType.CanNotarize]: {
		display: 'Can Notarize (Action)',
		value: EmployeePermissionsType.CanNotarize,
		type: SaturnPermissionType.Other,
	},
	// #endregion
};

export default class EmployeePermissionsEnumsHelper extends EnumHelper<EmployeePermissionsType> {
	static toList: ToListItems<EmployeePermissionsType>[] = Object.values(EmployeePermissionsMap);

	constructor() {
		super(EmployeePermissionsEnumsHelper.toList);
	}

	/**
	 * Gets the permissions by type.
	 * @param permissionType - The permission type.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The permissions by type.
	 */
	static getPermissionsByType(permissionType: SaturnPermissionType): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter((permission: any) => permission.type === permissionType);
	}

	/**
	 * Gets the permissions that allows users to access main Saturn pages.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The pages permissions.
	 */
	static getPagesPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Pages);
	}

	/**
	 * Gets the permissions that allows users to access customer features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The customers permissions.
	 */
	static getCustomersPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Customers);
	}

	/**
	 * Gets the permissions that allows users to access deal features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The deals permissions.
	 */
	static getDealsPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Deals);
	}

	/**
	 * Gets the permissions that allows users to access cancel coverage features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The cancel coverage permissions.
	 */
	static getCancelCoveragePermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.CancelCoverage);
	}

	/**
	 * Gets the permissions that allows users to access service lookup features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The service lookup permissions.
	 */
	static getServiceLookupPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.ServiceLookup);
	}

	/**
	 * Gets the permissions that allows users to access report features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The report permissions.
	 */
	static getReportsPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Reports);
	}

	/**
	 * Gets the permissions that allows users to access settings features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The settings permissions.
	 */
	static getSettingsPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Settings);
	}

	/**
	 * Gets the permissions that allows users to access utilities features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The utilities permissions.
	 */
	static getUtilitiesPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Utilities);
	}

	/**
	 * Gets the permissions that allows users to access checklist features.
	 * @returns {ToListItems<EmployeePermissionsType>[]} The checklist permissions.
	 */
	static getChecklistPermissions(): ToListItems<EmployeePermissionsType>[] {
		return EmployeePermissionsEnumsHelper.toList.filter(p => p.type === SaturnPermissionType.Checklist);
	}
}
